import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@/components/page";
import { NewFeature } from "@/components/ui/new-feature";
import { useRequiredRole } from "@/hooks/useRequiredRole";
import { AdminDashboard } from "./dashboard/-components/admin-dashboard";
import { MemberDashboard } from "./dashboard/-components/member-dashboard";

export const Route = createFileRoute("/_authed/_org/dashboard")({
  component: RouteComponent,
});

function RouteComponent() {
  const { viewOnlyAdmin } = useRequiredRole();

  return (
    <Page heading="Dashboard">
      <div className="flex @4xl/page:flex-row flex-col @6xl/page:gap-8 gap-4 @md/page:px-6 px-2 py-4">
        {viewOnlyAdmin ? <AdminDashboard /> : <MemberDashboard />}
      </div>
      <NewFeature />
    </Page>
  );
}
